<template>
	<div class="setbaojia">
		<el-row v-if="isdetail">
			<el-col :span="5" style="padding-left:5px;">
				<i class="el-icon-s-flag" style="color: #f5a25e;font-size:18pt;"></i>
				<span style="font-size:15pt;margin-left:5px;color: #f5a25e;">{{info.cname}}</span>
			</el-col>
			<el-col :span="5">
				<span>{{setbaojia_lang.starttime}}</span>
				<span style="margin-left:10px;">{{info.starttime}}</span>
			</el-col>
			<el-col :span="5">
				<span>{{setbaojia_lang.currency}}</span>
				<span  style="margin-left:10px;">{{info.currency}}</span>
			</el-col>
		</el-row>
		<el-form :inline="true" size="mini" style="padding-left:10px" label-width="80" v-if="!isdetail">
			<el-form-item :label="setbaojia_lang.title">
				<el-input type="text" v-model="info.cname" style="width:200px"></el-input>
			</el-form-item>
			<el-form-item :label="setbaojia_lang.type" >
				<el-select @change="changetype" v-model="info.type" style="width:150px" :disabled="info.c_id!=''">
					<el-option v-for="item in typeoptions"  :key="item.value"  :label="item.value" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="setbaojia_lang.starttime">
			  <el-date-picker
				  v-model="info.starttime"
				  type="date" style="width:150px">
				</el-date-picker>
			</el-form-item>
			<el-form-item :label="setbaojia_lang.currency">
				<el-select v-model="info.currency" style="width:150px;" >
					<el-option v-for="item in currencylist"  :key="item.value"  :label="item.value" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<el-row>
			<air ref="air" v-if="info.type=='空运'" :item="item" :isdetail="isdetail"></air>
			<!-- <express ref="express" v-if="info.type=='快递电商'" :item="item"></express> -->
			<clearance ref="clearance" v-if="info.type.indexOf('清关费')>-1||info.type=='快递电商'" :item="item" :isdetail="isdetail"></clearance>
		</el-row>
		<el-row class="footerhandler" v-if="!isdetail">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="saveScheme">{{$lang.label.public.savebtn}}</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">{{$lang.label.public.cancel}}</div></el-col>
		</el-row>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import air from '@/pages/transport/baojia_air.vue';//空运运费
//import express from '@/pages/transport/baojia_express.vue';//快递电商
import clearance from '@/pages/transport/baojia_clearance.vue';//清关费
// import { data } from 'vue-echarts';
export default {
	components: {
		air,
		//express,
		clearance
	},
	props: {
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		isdetail:{
			type:Boolean,
			default:false
		}
	},
	data() {
		return {
			info:{
				c_id:'',
				cname:'',
				remark:'',//备注,富文本框
				type:'空运',//报价方案类型，比如空运、海运清关
				starttime:'',//方案生效日期
				currency:''//币种
			},
			typeoptions:[{value:'空运'},{value:'海运清关费'},{value:'空运清关费'},{value:'快递电商'}],
			setbaojia_lang:{},
			currencylist:[],
			divclass:'setbaojia',
			isedit:0,
			endport:''
			//flightlist:[],
			//flightinfo:{}
		}
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/cw/setbaojia.scss');
		if(!this.isdetail)
			this.init();
	},
	methods:{
		init(){
			debugger
			//this.flightlist=[];
			if(this.item.isedit!=undefined){
				this.isedit=this.item.isedit;
			}
			if(this.item.row!=undefined){
				if(this.item.row.c_id!=undefined&&this.item.row.c_id!='')
					this.info.c_id=this.item.row.c_id;
				if(this.item.row.endport!=undefined)
					this.endport=this.item.row.endport;
			}
			//this.info.c_id="e72a19f6-440a-4526-bb3f-57fc76ca4190";//"982b87ca-d11a-44e5-8e4d-0ef00e97bee4";
			this.loadlanguage();
			if(!this.isdetail)
				this.loadcurrencylist();
		},
		loadbaojia(){
			var that=this;
			//debugger
			this.$apipost.get.GetSchemeMain({c_id:this.info.c_id}).then(res=>{
				if(res.state=='1')
				{
					that.info=res.info;
					that.changetype();
				}else
					this.$tool.message(that.setbaojia_lang.getinfofail, 0);
			});
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('setbaojia',this).then(res=>{
				if(res.state=='1')
					that.setbaojia_lang=that.$lang.label.setbaojia;
				if(that.info.c_id!='')
					that.loadbaojia();
				else 
					that.changetype();
			});
		},
		changetype(){
			var that=this;
			//debugger
			if(this.info.type=='空运'){
				this.$nextTick(function(){
					this.$refs.air.init({c_id:this.info.c_id,info:this.info,endport:this.endport});
				});
			}
			if(this.info.type.indexOf('清关费')>-1||this.info.type=='快递电商'){
				this.$nextTick(function(){
					this.$refs.clearance.init({c_id:this.info.c_id,info:this.info,endport:this.endport});
				});
			}
		},
		loadcurrencylist(){
			var that=this;
			this.$apipost.get.dic({type:'币别'}).then(res=>{
				if(res.list!=undefined){
					that.currencylist=res.list;
				}
			});
		},
		GetSchemeObj(){
			var that=this;
			var list=[];
			var weightlist=[];
			if(this.info.cname.trim()==''){
				this.$tool.message(this.$lang.label.public.pleasewrite+this.setbaojia_lang.title, 0);
				return false;
			}
			if(this.info.type==''){
				this.$tool.message(this.$lang.label.public.pleaseselect+this.setbaojia_lang.type, 0);
				return false;
			}
			if(this.info.currency==''){
				this.$tool.message(this.$lang.label.public.pleaseselect+this.setbaojia_lang.currency, 0);
				return false;
			}
			var paraminfo={};
			var datalist=[];
			if(that.info.type=='空运'){
				var isgo=true;
				this.info.remark=this.$refs.air._data.editor.txt.html();
				list=this.$refs.air._data.list;
				//debugger
				var lang=this.$refs.air._data.baojia_air_lang;
				list.forEach(e=>{
					if(e.startport==''){
						this.$tool.message(that.$lang.label.public.pleaseselect+lang.startport, 0);
						isgo=false;
					}
					if(isgo){
						e.setlist.forEach(s=>{
							if(s.endport==''){
								this.$tool.message(that.$lang.label.public.pleaseselect+lang.endport, 0);
								isgo=false;
							}
							if(isgo){
								var weightprice=[];
								s.weightprice.forEach(b=>{
									var wp={};
									wp.startport=e.startport;
									wp.endport=s.endport;
									for(var i in b){
										wp[i]=b[i];
										// if(i!="packagetype"&&i!='packagelocation'&&i!='endport'&&i!='remark'&&i!='startport'){
										// 	if(b[i].replace(/ /g,'')!=""){
										// 		if(isNaN(Number(b[i]))){
										// 			this.$tool.message(lang[i.toString()]+that.$lang.label.public.pleasewritenumber, 0);
										// 			isgo=false;
										// 		}
										// 	}
										// }
										if(!isgo)
											break;
									}
									wp.remark=s.remark;
									weightprice.push(wp);
									if(!isgo)
										return false;
								});
								if(isgo)
								{
								 if(datalist.length>0)
									datalist=datalist.concat(weightprice);
								 else
									datalist=weightprice;
								}
								else
									return false;								
							}
							else
								return false;
						});
					}
					else
						return false;
				});
				if(!isgo)
					datalist=[];
			}
			else{
				this.info.remark=this.$refs.clearance._data.editor.txt.html();
				datalist=this.$refs.clearance._data.list;			
			}
			if(datalist.length>0){
				paraminfo.maininfo=this.info;
				paraminfo.list=datalist;
			}else
				paraminfo='';
			return paraminfo;
		},
		saveScheme(){
			var that=this;
			var paraminfo=this.GetSchemeObj();
			if(paraminfo!=''){
				paraminfo.maininfo.u_userid=localStorage.getItem('userid');
				paraminfo.maininfo.u_account=localStorage.getItem('u_account');
				this.$tool.loading(this.$lang.label.public.saving,this.divclass);
				this.$apipost.post.SaveSchemeMain({paraminfo:paraminfo.maininfo}).then(res=>{
					if(res.state=='1')
					{
						//保存明细
						that.SaveSchemelist(paraminfo.list,res.id);
					}else
					{
						this.$tool.loadingclose();
						this.$tool.message(that.$lang.label.public.savefail, 0);
					}
				});
			}
		},
		SaveSchemelist(list,id){
			var that=this;
			//debugger
			var paraminfo={c_id:id,list:list,isedit:this.isedit};
			this.$apipost.post.SaveSchemeList({paraminfo:paraminfo}).then(res=>{
				
				if(res.state=='1')
				{
					that.successfun();
					// if(that.info.type=='空运'&&that.flightlist.length>0){
					// 	//保存空运信息
					// 	that.saveflight();
					// }
					// else{
					// 	this.$tool.loadingclose();
					// }
				}else
					this.$tool.message(that.$lang.label.public.savefail, 0);
			});
		},
		// saveflight(){
		// 	var that=this;
		// 	debugger
		// 	var paraminfo=this.info.flightinfo;
		// 	if(paraminfo!=''){
		// 		paraminfo.handleraccount=localStorage.getItem('u_account');
		// 		this.$tool.loading(this.$lang.label.public.saving,this.divclass);
		// 		this.$apipost.post.SaveFlightMain({paraminfo:paraminfo.maininfo}).then(res=>{
		// 			if(res.state=='1')
		// 			{
		// 				//保存明细
		// 				that.Saveflightlist(paraminfo.list,res.id);
		// 			}else
		// 			{
		// 				this.$tool.loadingclose();
		// 				this.$tool.message(that.$lang.label.public.savefail, 0);
		// 			}
		// 		});
		// 	}
		// },
		// Saveflightlist(id){
		// 	var that=this;
		// 	debugger
		// 	var paraminfo={f_id:id,list:this.flightlist};
		// 	this.$apipost.post.SaveSchemeList({paraminfo:paraminfo}).then(res=>{
		// 		this.$tool.loadingclose();
		// 		if(res.state=='1')
		// 		{
		// 			if(that.info.type=='空运'&&that.flightlist.length>0){
		// 				//保存空运信息
		// 			}
		// 		}else
		// 			this.$tool.message(that.$lang.label.public.savefail, 0);
		// 	});
		// },
		successfun(){
			var that=this;
			this.$tool.message(this.$lang.label.public.savesuccess,1);
			setTimeout(function(){
				that.cancel();
			},500);
		},
		cancel(){
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		setflightdata(e){
			//debugger
		}
	}
}
</script>

<style>
</style>